import i18next from 'i18next';
export const getUserLocale = () => {
    const userLocale = i18next.language;
    return userLocale === 'lt' ? 'lt' : 'en';
};
